import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnName,
  columnApproved,
  columnDenied,
  columnTotal,
  columnTotalTransfers,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const DictionariesMetricsHeaderRow = () => (
  <Table.Row>
    <UnsortedColumn columnId={columnName} textAlign="left" />
    <UnsortedColumn columnId={columnTotal} textAlign="right" />
    <UnsortedColumn columnId={columnApproved} textAlign="right" />
    <UnsortedColumn columnId={columnDenied} textAlign="right" />
    <UnsortedColumn columnId={columnTotalTransfers} textAlign="right" />
  </Table.Row>
);

export default DictionariesMetricsHeaderRow;
